import { SET_LOCK_EVENT_DATAS } from '../constants/LockEventDataConstants';

const initialState = {
  lockEventDatas: {
    list: [],
    count: 0,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOCK_EVENT_DATAS: {
      return {
        ...state,
        lockEventDatas: {
          list: action.payload.list,
          count: action.payload.count,
        },
      };
    }

    default: {
      return state;
    }
  }
}
